import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BusyContainer, Popup, MessagesContainer, ErrorComponent, Search, HelpImageContainer } from '../components';
import { SiteHeader, BreadcrumbHeader, SiteFooter } from '.';
import { blurOnSearchState, combineStates, currentNodeState, currentPageDispatcher, currentPageState, dialogDispatcher, dialogState, flagState, identityState, messageDispatcher, mobilePageViewState, nodeState, screenDispatcher, screenSizeDispatcher, screenSizeState, screenState, showConfigureState, showFooterState, siteSettingsState } from '../store';
import { configuratorActions, hierarchyNodeActions, translate } from '../services';
import { desanitize, isIE } from '../util';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { CookiesConsent } from './components/navigation';
import { AppBar, Box, CssBaseline, Dialog, DialogContent, Grid } from '@mui/material';
import {isTablet} from 'react-device-detect';

function getMatchingItem( item, childProp, equalFn ) {
  if ( equalFn( item ) ) {
    return item;
  }
  let children = item[childProp];
  if ( !children || !children.length ) {
    return null;
  }
  for ( let i = 0; i < children.length; i++ ) {
    let result = getMatchingItem( children[i], childProp, equalFn );
    if ( result ) {
      return result;
    }
  }
  return null;
}

function findNode( selectors, path ) {
  let uid = nodeIdFromPath( path );
  return uid === '0' ? selectors : getMatchingItem( selectors, 'children', item => item.uuid === uid || item.nodeId === uid ) || selectors;
}

function nodeIdFromPath( path ) {
  let parts = path.split( '/' );
  return desanitize( parts[parts.length - 1] );
}

function getGAPathString( node ) {
  return node.parent 
    ? `${ getGAPathString( node.parent ) }/${ node.name }`
    : node.name;
}

class HomeAppComponent extends Component {
  static getDerivedStateFromError( error ) {
    return {
      hasError: true,
      error
    };
  }
  constructor( props ) {
    super( props );
    this.pageCounter = 0;
    this.state = {
      isInErrorMode: false,
      error: null,
      alignment:"listView",
      isSearchOn: false,
      searchString:"",
    };
  }
  
  componentDidMount() {
    this.unlisten = this.props.history.listen( ( ...args ) => this.syncNodeToRoute( ...args ) );
    this.syncNodeToRoute( { pathname: document.location.hash } );
    window.addEventListener( 'resize', this.onResize );
    window.addEventListener( 'beforeunload', ()=>{
      sessionStorage.removeItem("selectedAccessorySelections");
      sessionStorage.removeItem("currentSelectedProduct");
    } );


    if(this.props.screenSize.width===0 || this.props.screenSize.height===0){
      this.props.resizeScreen();
    }
    if( isIE() ) {
      this.props.addMessage( { 
        messageType: 'warning', 
        messageText: translate( 'Please note that Internet Explorer is not fully supported anymore. Please consider to use one of the following browsers: Google Chrome, Mozilla Firefox, Mircosoft Edge' ) } );
    }
  }

  componentWillUnmount() {
    this.unlisten();
    window.removeEventListener( 'resize', this.onResize );
  }

  onResize = () => {
    this.timeout && clearTimeout( this.timeout );
    this.timeout = setTimeout( () => {this.props.resize(); this.props.resizeScreen();}, 100 );
  };

  syncNodeToRoute = ( { pathname } ) => {
    const { dispatch, currentNode, node, updateGA } = this.props;
    if(pathname=="/categories/"){
      document.location.hash="#/categories";
    pathname=document.location.hash}
    const showCategory = pathname.includes( 'categories' ) || pathname.includes( 'selector' ) || pathname.includes( 'configurator' );
    this.pageCounter++;

    if ( showCategory ) {
      const foundNode = findNode( node, pathname );
      if ( foundNode !== currentNode ) {
        dispatch( { type: hierarchyNodeActions.SETNODE, node: foundNode } );
        updateGA( getGAPathString( foundNode ) );
      }
    } else {
      updateGA( pathname );
    }
  };

  onBack = () => this.pageCounter = this.pageCounter - 2;
  
  // for mobile toggle between tree and image view
  handleAlignment = (event, newAlignment) => {
    this.setState( { alignment: newAlignment } );
  };

  setSearchMobileView = () => this.setState({isSearchOn:true})

  checkPage = () => this.props.mobileViewPage.showPage==="search"||this.props.mobileViewPage.showPage==="cart"

  onClose = ()=>{
    this.props.closeDialog();
  }

  setSearchString = (value)=>{
    this.setState({searchString:value})
  }
  render() {
    const { children, isBusy, screen, siteSettings, user , landingpagecart} = this.props;
    const { hasError, error } = this.state;
    const isFile = user.authenticationType === 'File';
    // return <BusyContainer className={ classNames( 'site-container', user.country.toLowerCase(), { 'mobile': screen.isMobile, 'tablet': screen.isTablet } ) } isBusy={ isBusy }>
    //   <Popup />
    //   <SiteHeader isIntegrated={ siteSettings.isIntegrated } path={ document.location.hash }/>
    //   <BreadcrumbHeader 
    //     setBack={ this.pageCounter > 1 }
    //     onBack={ this.onBack }
    //     isIntegrated={ siteSettings.isIntegrated } 
    //     pathname={ document.location.hash }
    //   />
    //   <div className="content">
    //     { hasError ? <ErrorComponent error={ error } /> : children }
    //   </div>
    //   <MessagesContainer />
    //   {isFile && <CookiesConsent/>}
    //   <SiteFooter />
    // </BusyContainer>;y
    const styles = {
      dialogPaper: {
          minHeight: '80vh',
          maxHeight: '80vh',
      },
  };
    return(
      <>
      <BusyContainer className={ classNames( 'site-container', user.country.toLowerCase(), { 'mobile': screen.isMobile, 'mobile': screen.isMobile, 'tablet-device': isTablet} ) } isBusy={ isBusy }>
        {this.props.blurOnSearch.show&&<div className='blurOnSearch'>
        </div>}
        <Dialog open={this.props.dialog.show} onClose={this.onClose}  PaperProps={{className:this.props.dialog.item?.className, sx:{overflow:"hidden",position:"absolute", top:{md:this.props.dialog.item==="bom-item-missing"?"135px":"auto", xs:"auto"}}}}>
            {this.props.dialog.component}
        </Dialog>
        <Popup/>
        <MessagesContainer />
        <Grid container sx={{height:"100vh"}} xl={12} xs={12} md={12} overflowY="auto">
          <Grid border={0} position="relative" sx={{height:{xl:"72px", md:"72px", lg:"72px", xs:"80px"},boxShadow: {md:"0px 2px 6px rgba(0, 0, 0, 0.15)", xs:"none"},zIndex:{md:"10", xs:"0"}, width:"100%"}}>
            <Box sx={{display:{md:"flex", xs:"flex"}, height:{xl:"71px", md:"71px", lg:"71px", xs:"80px"}, width:"100%"}}>
                <SiteHeader pageCounter={this.pageCounter} onBack={this.onBack} isIntegrated={ siteSettings.isIntegrated } path={ document.location.hash } alignment={this.state.alignment} handleAlignment={this.handleAlignment} setSearchString={this.setSearchString} onClose={this.onClose} landingpagecart={landingpagecart} ></SiteHeader>   
            </Box>
          </Grid>
          <Grid item container border={0} xl={12} xs={12} md={12} sx={{height:!this.props.showFooter.show || this.props.showConfigure.show?{md:"calc(100vh - 72px)", xs:"calc(100% - 80px)"}:{md:"calc(100% - 127px)", xs:"calc(100% - 80px)"}, overflowY:"hidden", overflowX:"hidden", position:"fixed", top:{md:"72px", xs:"80px"}}}>
          { hasError ? <ErrorComponent error={ error } /> : this.props.mobileViewPage.showPage!=="search" &&  children }
            {this.props.mobileViewPage.showPage==="search"&&!this.props.showConfigure.show&&
            // <Grid item xs={12} sx={{height:{md:"none", xs:"100%"}, display:{md:"none"}, overflowY:"auto"}}>
            //   <Search mobileView={true} searchString={this.state.searchString}></Search>
            // </Grid>
            <div className='mobile-search'>
              <Search mobileView={true} searchString={this.state.searchString}></Search>
            </div>}
            {
              this.props.showConfigure.show && this.props.showConfigure.component
            }
          </Grid>
            {
              !this.props.showConfigure.show&&
              <Grid item container border={0} xl={12} xs={12} md={12} sx={{borderTop: "1px solid #DBDBDB", display:!this.props.showFooter.show?"none":{xl:"flex", lg:"flex", md:"flex", xs:"none"}, height:{xl:"56px",lg:"56px", md:"56px", xs:"108px"}, position:"fixed", bottom:"0px"}}>
              {isFile && <CookiesConsent/>}            
              <SiteFooter></SiteFooter>
            </Grid>
            }
        </Grid>
        </BusyContainer>
      </>
    )
  }
} 

HomeAppComponent.propTypes = {
  addMessage: PropTypes.func.isRequired,
  children: PropTypes.oneOfType( [PropTypes.node, PropTypes.arrayOf( PropTypes.node )] ),
  currentNode: PropTypes.shape( {} ).isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.shape( {
    listen: PropTypes.func.isRequired
  } ),
  isBusy: PropTypes.bool,
  node: PropTypes.shape( {} ).isRequired,
  screen: PropTypes.shape( {
    isMobile: PropTypes.bool.isRequired,
    isTablet: PropTypes.bool.isRequired
  } ),
  siteSettings: PropTypes.shape( {
    isIntegrated: PropTypes.bool.isRequired
  } ).isRequired,
  updateGA: PropTypes.func.isRequired,
  user: PropTypes.shape( {
    country: PropTypes.string.isRequired
  } ),
};

export const HomeApp = withRouter( connect( 
  combineStates( currentNodeState,blurOnSearchState, identityState, nodeState, screenState,screenSizeState, siteSettingsState, mobilePageViewState, showFooterState, showConfigureState, dialogState, flagState, currentPageState
     ), 
  dispatch => ( { ...screenDispatcher( dispatch ), ...messageDispatcher( dispatch ),...dialogDispatcher(dispatch), dispatch, ...currentPageDispatcher(dispatch), ...screenSizeDispatcher(dispatch)} )
)( HomeAppComponent ) );